<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      MATCHED
    </button>

    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      UNMATCHED
    </button>

    <button [ngClass]="{ active: selectedTab === 2 }" (click)="selectedTab = 2">
      PROCESSED
    </button>
  </div>
  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-plan-linkage-unprocessed
        *ngSwitchCase="0" [selectedTab]="0"
      ></app-plan-linkage-unprocessed>

      <app-plan-linkage-unprocessed
        *ngSwitchCase="1" [selectedTab]="1"
      ></app-plan-linkage-unprocessed>

      <app-plan-linkage-processed
        *ngSwitchCase="2"
      ></app-plan-linkage-processed>
    </ng-container>
  </div>
</div>
